// src/frontend/pages/Home.jsx
import React, {useEffect, useState} from 'react';
import {useRoom} from '../context/RoomContext';
import toast from 'react-hot-toast';
import {BsArrowCounterclockwise, BsShuffle} from 'react-icons/bs';

export default function Home() {
    const {joinRoom} = useRoom();
    const [roomId, setRoomId] = useState('');
    const [username, setUsername] = useState('');

    const generateRandomName = () => {
        const prefixes = ['Gast', 'Besucher', 'User', 'Player', 'Explorer'];
        const suffix = Math.floor(Math.random() * 9999).toString().padStart(4, '0');
        return `${prefixes[Math.floor(Math.random() * prefixes.length)]}-${suffix}`;
    };

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const paramRoom = params.get('room');
        const paramUser = params.get('user');
        const isQuickJoin = params.has('quickjoin') || params.get('quick') === '1';

        if (paramRoom) {
            setRoomId(paramRoom);
            setUsername(paramUser || '');

            if (isQuickJoin) {
                // QuickJoin: Sofort joinen mit Name (aus Link oder random)
                const finalUsername = paramUser?.trim() || generateRandomName();
                setUsername(finalUsername);
                joinRoom(paramRoom, finalUsername);
                toast.success(`QuickJoin als ${finalUsername}! 🚀`);

                // URL bereinigen: quickjoin entfernen
                const cleanParams = new URLSearchParams();
                cleanParams.set('room', paramRoom);
                const newUrl = `${window.location.pathname}?${cleanParams.toString()}`;
                window.history.replaceState({}, '', newUrl);
            }
        }
    }, [joinRoom]);

    const handleJoin = () => {
        if (!roomId.trim()) {
            toast.error('Bitte eine Room-ID eingeben!');
            return;
        }

        const finalUsername = username.trim() || 'anonymous';
        joinRoom(roomId, finalUsername);
        toast.success(`Raum betreten als ${finalUsername}!`);
    };

    // NEU: Generiere zufällige Raum-ID
    const handleGenerateId = () => {
        const randomId = `raum-${Math.floor(Math.random() * 999999).toString().padStart(6, '0')}`;
        setRoomId(randomId);
        toast.success(`Neue Raum-ID: ${randomId}`);
    };

    // NEU: Reset Raum-ID + URL
    const handleReset = () => {
        setRoomId('');
        setUsername('');
        window.history.replaceState({}, '', window.location.pathname);  // URL komplett resetten
        toast.success('Eingaben zurückgesetzt');
    };

    return (
        <div className="flex-1 flex items-center justify-center px-4 py-12">
            <div className="w-full max-w-md">
                <div className="text-center mb-10">
                    <h1 className="text-5xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent mb-4">
                        RP LiveCollab
                    </h1>
                    <p className="text-lg text-gray-600 dark:text-gray-400">
                        Echtzeit-Text- und Datei-Zusammenarbeit
                    </p>
                </div>

                <div
                    className="bg-white/80 dark:bg-white/5 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/20 p-8">
                    <h2 className="text-2xl font-bold text-center mb-8 text-gray-800 dark:text-white">
                        Raum beitreten
                    </h2>

                    <div className="space-y-6">
                        <div className="relative">
                            <label className="block text-sm font-semibold mb-2 text-gray-700 dark:text-gray-300">
                                Raum-ID
                            </label>
                            <input
                                type="text"
                                value={roomId}
                                onChange={(e) => setRoomId(e.target.value)}
                                placeholder="z. B. mein-cooler-raum"
                                className="w-full px-4 py-3 rounded-xl bg-gray-100 dark:bg-white/10 border border-gray-300 dark:border-white/20 focus:border-blue-500 focus:ring-4 focus:ring-blue-500/20 transition-all outline-none"
                            />
                            <button
                                onClick={handleGenerateId}
                                className="absolute right-2 top-[34px] p-2 rounded-full bg-green-600 text-white hover:bg-green-700 transition-colors"
                                title="Zufällige Raum-ID generieren"
                            >
                                <BsShuffle size={18}/>
                            </button>
                        </div>

                        <div>
                            <label className="block text-sm font-semibold mb-2 text-gray-700 dark:text-gray-300">
                                Dein Name (optional)
                            </label>
                            <input
                                type="text"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                placeholder="z. B. Sven"
                                className="w-full px-4 py-3 rounded-xl bg-gray-100 dark:bg-white/10 border border-gray-300 dark:border-white/20 focus:border-blue-500 focus:ring-4 focus:ring-blue-500/20 transition-all outline-none"
                            />
                        </div>

                        <div className="flex gap-4">
                            <button
                                onClick={handleReset}
                                className="flex-1 py-3 rounded-xl bg-gray-600 text-white font-medium hover:bg-gray-700 transition-colors flex items-center justify-center gap-2"
                                title="Eingaben zurücksetzen"
                            >
                                <BsArrowCounterclockwise size={18}/>
                                Reset
                            </button>
                            <button
                                onClick={handleJoin}
                                className="flex-1 py-3 rounded-xl bg-gradient-to-r from-blue-600 to-purple-600 text-white font-bold hover:from-blue-700 hover:to-purple-700 transition-colors"
                            >
                                Raum betreten 🚀
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}